import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';

import DropdownWrapper from '../DropdownWrapper';

const BenefitsNavGroup = ({ userIsLoggedIn }) => {
  return (
    <DropdownWrapper>
      <LinkNav
        to={getPageLink('page-membership-benefits')}
        className="nav-link"
      >
        Benefits
      </LinkNav>
      <div className="dropdown-menu">
        <div className="dropdown-wrapper">
          <div className="links-title">
            <LinkNav to={getPageLink('page-membership-benefits')}>
              Membership Benefits
            </LinkNav>
            <p>
              Military Benefit Association provides benefits and services to
              help members fortify their financial position. Membership is free.
            </p>
          </div>
          <div>
            <LinkNav
              to={getPageLink('page-eligibility')}
              className="dropdown-item"
            >
              Eligibility
            </LinkNav>
            <LinkNav
              to={getPageLink('page-benefits-offered')}
              className="dropdown-item"
            >
              Benefits of Membership
            </LinkNav>
            {!userIsLoggedIn && (
              <LinkNav
                to={getPageLink('page-become-a-member')}
                className="dropdown-item"
              >
                Become a Member
              </LinkNav>
            )}
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default BenefitsNavGroup;
